// App-specific config using modern ES2015+ export...
// For teh rest of the system EXCEPT for vue.config.js
export default {
  title: 'Recipe Planning by Menūd',
  description: "Shop for a week's worth of groceries in 30 seconds",
  TOUCH_ICON: 'https://res.cloudinary.com/menud/image/upload/v1583511273/menud-touch-icon_1x_krqbtq.png',
  NAME: 'Menud',
  LOGO: 'https://res.cloudinary.com/menud/image/upload/v1560982217/logo_fi9l3p.png',
  NODE_ENV: 'production',
  API_BASE_URL: 'https://app.menud.co',
  THEME: 'Menud',
  TANDEM_API_BASE_URL: 'https://tandem.green',
  DEBUG: false,
  THEME: process.env.VUE_THEME,
  CLEVERTAP_ACCT_ID: '',
  PLANS_ENABLED: true,
  MACROS_ENABLED: true,
  SHOPPING_ENABLED: false,
  BRANCH_KEY: 'key_live_diB8lUXePM5xrzYp3vmb1chmEraDDok0',
  LP_APP_ID: '',
  LP_APP_KEY: '',
};
